module.exports = __webpack_public_path__ + "img/account-eye.2d773afe.svg";